import * as types from "../Action/type";

const initialState = {
    loading: false,
    removeflag:true,
    token: null,
    rule:null,
    type:null,
    error: null,

}
const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_LOGIN_REQUEST:
            return { ...state, loading: true, error: null };
        case types.FETCH_LOGIN_SUCCESS:
        console.log("actions take place rules",action.payload.user.rules)
            return {
                ...state,
                token: action.payload.token,
                rule: action.payload.user.rules,
                type:action.payload.user.type,
                removeflag:true
            };
        case types.REMOVE_TOKEN:
            return {
                ...state,
                removeflag:false,
                token: null,
                rule:null,
                type:null,
                loading: false,
            };
        case types.INTIALIZE:
            console.log("intiaslizing", action.rules)
            return {
                ...state,
                removeflag:true,
                token: action.Payload.token,
                rule: action.Payload.rules,
                type:action.Payload.type,
                loading: false,
            };
        case types.FETCH_LOGIN_FAIL:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }

}
export default AuthReducer;